module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFood),
      expression: "isShowFood"
    }],
    ref: "food",
    staticClass: "food"
  }, [_c('div', {
    staticClass: "food-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.food.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hide($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow_lift"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.food.name))]), _vm._v(" "), _c('div', {
    staticClass: "count-rating"
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v("月售" + _vm._s(_vm.food.sellCount))]), _vm._v(" "), _c('span', {
    staticClass: "rating"
  }, [_vm._v("好评率" + _vm._s(_vm.food.rating) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "price-wrap"
  }, [_c('span', {
    staticClass: "price"
  }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(_vm.food.price))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "old-price"
  }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(_vm.food.oldPrice))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "btn-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.count || _vm.food.count === 0),
      expression: "!food.count || food.count===0"
    }],
    staticClass: "add-cart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addCart($event)
      }
    }
  }, [_vm._v("加入购物车")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "btn-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.count || _vm.food.count !== 0),
      expression: "food.count || food.count!==0"
    }],
    staticClass: "control-wrap"
  }, [_c('cartcontrol', {
    attrs: {
      "food": _vm.food
    }
  })], 1)])], 1), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "desc-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("商品介绍")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.food.info))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "rating-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("商品评价")]), _vm._v(" "), _c('ratingselect', {
    attrs: {
      "ratings": _vm.food.ratings,
      "desc": _vm.desc,
      "select-type": _vm.selectType,
      "only-content": _vm.onlyContent
    },
    on: {
      "select": _vm.selectRatings,
      "toggle": _vm.toggleContent
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "rating-list"
  }, _vm._l((_vm.food.ratings), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.needShow(item.rateType, item.text)),
        expression: "needShow(item.rateType,item.text)"
      }],
      staticClass: "rating-item border-1px"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.rateTime)))]), _vm._v(" "), _c('div', {
      staticClass: "rating-content"
    }, [_c('span', {
      staticClass: "icon",
      class: {
        'icon-thumb_up': item.rateType === 0, 'icon-thumb_down': item.rateType === 1
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "username"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.ratings),
      expression: "!food.ratings"
    }],
    staticClass: "not-rating"
  }, [_vm._v("\n          暂无评论\n        ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08774c05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/food/food.vue
// module id = 67
// module chunks = 0